import React from 'react';
import { decl } from '@yandex-lego/i-bem-react';

import _popup2__tail from "./../../popup2/__tail/popup2__tail.react.js";

var PopupTail = _popup2__tail.applyDecls();

import "./../../popup2/__tail/popup2__tail.css";


export default decl({
    block: 'message-box',
    elem: 'tail',

    replace: function replace() {
        var tailSVG = React.createElement(
            'svg',
            { viewBox: '0 0 22 10' },
            React.createElement('path', { d: 'M20 10H0c5 0 7.949-3.872 10-9 2.051 5.128 5 9 10 9z', fill: 'currentColor' })
        );
        return React.createElement(
            PopupTail,
            { mix: { block: 'message-box', elem: 'tail' } },
            tailSVG
        );
    }
});